import React from 'react';
import PropTypes from 'prop-types';
import { ProductRender } from '@px/react-products';
import { render, update } from '@px/renderator';
import { Block } from '@px/react-utils';

function Item({ item, onChange }) {

  return (
    <Block m={{ bottom: 'small' }}>
      <ProductRender
        products={ render(item) }
        onChange={ (change) => onChange(update(change)) }
      />
    </Block>
  );
}

Item.propTypes = {
  item: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};

export default Item;
